export const sendStatus = [
  { id: 'draft', name: 'Bozza', title: 'Bozza' },
  // { id: 'scheduled', name: 'Programmato', title: 'Programmato' },
  { id: 'sent', name: 'Inviato', title: 'Inviato' },
];

export const getStatusTitle = (id: string) => {
  return sendStatus.find((type) => type.id === id)?.name;
};
